/* Defines the group for each state, used to differentiate by the generic reducer to decide which slice of state is invoking the reducer action */
/* Alphabetical sorting here PLEASE */

export const GROUP_AVAILABILITIES = 'availabilities';

export const GROUP_BILLING_INVOICE = 'invoice';
export const GROUP_BILLING_USER = 'user';

export const GROUP_CALENDAR_EVENTS = 'calendarEvent';

export const GROUP_ASSIGNED_CANDIDATES = 'assignedCandidates';
export const GROUP_SEARCH_CANDIDATES = 'searchCandidates';

export const GROUP_CERTIFICATES = 'certificate';
export const GROUP_CERTIFICATES_WORKERS = 'certificateWorkers';
export const GROUP_CERTIFICATE_SUMMARIES = 'certificateSummaries';

export const GROUP_COMPANY_LOCATION = 'companyLocation';
export const GROUP_COMPANY_SCHEDULE = 'companySchedule';
export const GROUP_CONNECTIONS = 'connections';
export const GROUP_CONNECTION_PERMISSIONS = 'connectionPermissions';

export const GROUP_REPORT_DELIVERIES_BY_DRIVERS = 'reportDeliveriesByDrivers'

export const GROUP_DISCLAIMERS = 'disclaimer';
export const GROUP_DISCLAIMER_VERSIONS = 'disclaimerVersion';

export const GROUP_DISPATCH_CONFIGS = 'dispatchConfigs';

export const GROUP_DRIVERS = 'drivers';

export const GROUP_API_KEYS = 'apiKeys';

export const GROUP_HOLIDAYS = 'holidays';
export const GROUP_HOLIDAY_ITEMS = 'holidayItems';

export const GROUP_JOBS = 'jobs';

export const GROUP_KIOSK = 'kiosk';
export const GROUP_KIOSK_USERS = 'kioskUsers';

export const GROUP_LABOR_SALES = 'laborSales';
export const GROUP_LABOR_SALES_GRAPH = 'laborSalesGraph';
export const GROUP_LABOR_SALES_CHANNEL = 'laborSalesChannel';

export const GROUP_LIVE_ATTENDANCE = 'liveAttendance';
export const GROUP_LIVE_ATTENDANCE_GRAPH = 'liveAttendanceGraph';
export const GROUP_LIVE_ATTENDANCE_DATA_ACTUAL = 'liveAttendanceDataActual';
export const GROUP_LIVE_ATTENDANCE_DATA_UPCOMING = 'liveAttendanceDataUpcoming';

export const GROUP_LIVEVIEW_ORDERS = 'liveViewOrders';

export const GROUP_LOCATION = 'location';
export const GROUP_LOCATION_RULES = 'locationRules';

export const GROUP_LOGBOOK_BOARD = 'logbookBoard';
export const GROUP_LOGBOOK_POST = 'logbookPost';

export const GROUP_MESSAGE = 'messages';
export const GROUP_MESSAGE_THREAD = 'messagesThread';

export const GROUP_NOTIFICATIONS = 'notifications';
export const GROUP_NETWORK = 'network';

export const GROUP_PAYROLLS = 'payrolls';
export const GROUP_PAYROLL_HISTORY = 'payrollHistory';
export const GROUP_PAYROLL_HISTORY_TIMECARDS = 'payrollHistoryTimecard';
export const GROUP_PAYROLL_QUIZZES = 'payrollQuizzes';

export const GROUP_POS_CONNECTIONS = 'posConnections';

export const GROUP_DELIVERY_ORDERS = 'deliveryOrders';
export const GROUP_DELIVERY_ORDER_CONFIGS = 'deliveryOrderConfigs';

export const GROUP_DEVSUPPORT_ORDERS = 'devSupportOrders';

export const GROUP_POSITION = 'position';
export const GROUP_POSITION_WORKERS = 'positionWorkers';

export const GROUP_QUIZZES = 'quiz';

export const GROUP_REPORT_SCHEDULED_ACTUAL_GRAPH = 'scheduledActualGraph';
export const GROUP_REPORT_SCHEDULED_ACTUAL_DATA = 'scheduledActualData';
export const GROUP_REPORT_NO_SHOW_DATA = 'noShowData';
export const GROUP_REPORT_CONTACT_TRACING_DATA = 'contactTracingData';
export const GROUP_RULES = 'rules';
export const GROUP_RULESETS = 'rulesets';

export const GROUP_SCHEDULE = 'schedule';
export const GROUP_SCHEDULE_MANAGERS = 'scheduleManager';
export const GROUP_SCHEDULE_USERS = 'scheduleUser';
export const GROUP_SCHEDULE_RULES = 'scheduleRules';
export const GROUP_SEARCH_WORKERS = 'searchWorkers';

export const GROUP_SHIFTS = 'shifts';

export const GROUP_TIMECARD = 'timecard';
export const GROUP_TIMECARDS = 'timecards';
export const GROUP_TIMECARD_EVENTS = 'timecardEvents';
export const GROUP_TIMECARD_QUIZZES = 'timecardQuizzes';

export const GROUP_TIMEOFF = 'timeoff';
export const GROUP_TIMEOFFS = 'timeoffs';

export const GROUP_TIPS_SALES = 'tipsSales';
export const GROUP_TIPS_SALES_GRAPH = 'tipsSalesGraph';

export const GROUP_WORKER_TIMECARDS = 'workerTimecards';

export const GROUP_WORKER_TIMEOFFS = 'workerTimeoffs';

export const GROUP_MOBILEBYTES_CONNECTIONS = 'mobilebytesConnections';
export const GROUP_MOBILEBYTES_LOCATIONS = 'mobilebytesLocations';

export const GROUP_POS_INTEGRATIONS = 'posIntegrations';
export const GROUP_POS_UNASSOCIATEDTIPS = 'posUnassociatedTips';

export const GROUP_SQUARE_CONNECTIONS = 'squareConnections';
export const GROUP_SQUARE_LOCATIONS = 'squareLocations';

export const GROUP_USERS = 'users';

export const GROUP_XERO_EMPLOYEES = 'xeroEmployees';
export const GROUP_XERO_CONNECTIONS = 'xeroConnections';
export const GROUP_XERO_TIMECARDS = 'xeroTimecards';
export const GROUP_XERO_EARNING_RATES = 'xeroEarningRates';
